import { TimespanRecord } from "../../../../../types/immutableRecords/model/data/TimespanRecord";
import { isDateValid } from "../../../../definition/calendar/dateFunctions";
import {
  isTimespanNegative,
  timespanBetweenTimespans
} from "../../../../definition/calendar/dateFunctions/timespanFunctions";
import { setTimespanProp } from ".";

export const setItemDurationToEarliestEnd = (obj, duration, calendar) => {
  if (obj.isDateLocked) {
    return obj;
  }
  const preferredDuration = obj.preferredDuration;
  const durationToEarliestEnd = TimespanRecord(duration);
  const startDate = obj.preferredStartDate;
  if (
    isDateValid(startDate) &&
    duration &&
    preferredDuration &&
    isTimespanNegative(timespanBetweenTimespans(startDate, durationToEarliestEnd, preferredDuration, calendar))
  ) {
    return obj;
  }
  return setTimespanProp(obj, duration, "durationToEarliestEnd");
};
